import React, { useEffect, useState } from "react";

const RangeInput = ({ inputValues, handleInputChange , maxInputWidth, hideAxis }) => {

  const [fieldInputs, setFieldInputs] = useState([
    {
      label: "SPH Min",
      name: "SPH_Min",
      tooltip: "SPH Range -40.00 to +40.00",
    },
    {
      label: "SPH Max",
      name: "SPH_Max",
      tooltip: "SPH Range -40.00 to +40.00",
    },
    {
      label: "Step",
      name: "SPH_Step",
      tooltip: "Step 0.25",
    },
    {
      label: "CYL Min",
      name: "CYL_Min",
      tooltip: "CYL Range -10.00 to +10.00",
    },
    {
      label: "CYL Max",
      name: "CYL_Max",
      tooltip: "CYL Range -10.00 to +10.00",
    },
    {
      label: "Step",
      name: "CYL_Step",
      tooltip: "Step 0.25",
    },
    {
      label: "Axis",
      name: "Axis",
      tooltip: "Axis separated by comma (Ex- 10,20,...etc)",
      type: "text",
    },
    {
      label: "Add Min",
      name: "Add_Min",
      tooltip: "Add Range 0.50 to +10.00",
    },
    {
      label: "Add Max",
      name: "Add_Max",
      tooltip: "Add Range 0.50 to +10.00",
    },
    {
      label: "Step",
      name: "Add_Step",
      tooltip: "Step 0.25",
    },
  ]);

  useEffect(()=>{

    const fields = [
      {
        label: "SPH Min",
        name: "SPH_Min",
        tooltip: "SPH Range -40.00 to +40.00",
      },
      {
        label: "SPH Max",
        name: "SPH_Max",
        tooltip: "SPH Range -40.00 to +40.00",
      },
      {
        label: "Step",
        name: "SPH_Step",
        tooltip: "Step 0.25",
      },
      {
        label: "CYL Min",
        name: "CYL_Min",
        tooltip: "CYL Range -10.00 to +10.00",
      },
      {
        label: "CYL Max",
        name: "CYL_Max",
        tooltip: "CYL Range -10.00 to +10.00",
      },
      {
        label: "Step",
        name: "CYL_Step",
        tooltip: "Step 0.25",
      },
      {
        label: "Add Min",
        name: "Add_Min",
        tooltip: "Add Range 0.50 to +10.00",
      },
      {
        label: "Add Max",
        name: "Add_Max",
        tooltip: "Add Range 0.50 to +10.00",
      },
      {
        label: "Step",
        name: "Add_Step",
        tooltip: "Step 0.25",
      },
    ];

    if(hideAxis === true){
      setFieldInputs(fields);
    }

  },[hideAxis]);

  return (
    <div className="ToolTipTOp">
      <div className="mt-1">
        <div className="input-box-m6">
          <div className="ToolBody">
            {fieldInputs.map(({ label, name, tooltip, type = "number" }, idx) => (
              <div key={idx} className="tooltip6" style={{  maxWidth: maxInputWidth ? maxInputWidth : "100px"}}>
                <label
                  className=""
                  style={{ textAlign: "center", marginLeft: "5px" }}
                >
                  {label}
                </label>
                <input
                  id={name.toLowerCase()}
                  className="table-input box-size1 toolTextWdth"
                  value={inputValues[name]}
                  onChange={handleInputChange}
                  name={name}
                  type={type}
                  required
                />
                <div className="tooltiptext">{tooltip}</div>
              </div>
            ))}

            {/* Eye (R/L/RL) */}
            <div className="tooltip6">
              <label
                className=""
                style={{ textAlign: "center", marginLeft: "5px" }}
              >
                Eye(RL/R/L)
              </label>
              <select
                className="modify_im_input mode_category table-input"
                style={{ width: "90px" }}
                value={inputValues.Eye}
                onChange={handleInputChange}
                name="Eye"
                required
              >
                <option value="" disabled></option>
                <option value="R">R</option>
                <option value="L">L</option>
                <option value="RL">RL</option>
              </select>
              <div className="tooltiptext">R/L/RL</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RangeInput;
